import React, { Component } from 'react';
import Img1 from '@/images/img_1.jpg';
import Img2 from '@/images/img_2.jpg';
import Img3 from '@/images/img_3.jpg';
import Img4 from '@/images/img_4.jpg';
import styles from './index.module.scss';

class Report extends Component {
  render() {
    return (
      <div className={styles.container}>
        <div className={styles.report}>
          <img src={Img1} alt="" />
          <img src={Img2} alt="" />
          <img src={Img3} alt="" />
          <img src={Img4} alt="" />
        </div>
      </div>
    );
  }
}

export default Report;
